<template>
	<div class="home">
		<swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
			<swiper-slide class="swiper-slide slide-one">
				<div class="page">
					<h3>长沙术仁堂中医医院</h3>
					<p>CHANG SHA SHU REN TANG HOSPITAL OF TCM</p>
				</div>
				<p class="slogan">术仁心 聚仁术</p>
			</swiper-slide>

			<swiper-slide class="swiper-slide slide-two">
				<div class="page">
					<h3>最新资讯</h3>
					<p>NEWS</p>
				</div>
				<div v-if="newsList != ''" class="news-content">
					<div class="news-content-item" v-for="(news,index) in newsList" :key="'news'+index">
						<div style="order: 1">
							<div v-if="news.isWechatArticle==1" @click="goTo(news.url)" style="cursor: pointer;">
								<div class="item-img" v-lazy:background-image="news.cdnUrl"></div>
							</div>
							<router-link v-else target="_blank" rel="noopener noreferrer" class="text-decoration"
								:to="{ name: 'article', params: { id: news.id }}">
								<div class="item-img" v-lazy:background-image="news.mainImg.src"></div>
							</router-link>
						</div>
						<div style="order: 2">
							<el-divider>
								<i class="el-icon-apple"></i>
							</el-divider>
						</div>
						<div class="item-content" style="order: 3">
							<div v-if="news.isWechatArticle==1" @click="goTo(news.url)" style="cursor: pointer;">
								<h3>{{news.title}}</h3>
								<p>{{news.content}}</p>
								<span>{{formatDate(news.createDate)}}</span>
							</div>
							<router-link v-else target="_blank" rel="noopener noreferrer" class="text-decoration"
								:to="{ name: 'article', params: { id: news.id }}">
								<h3>{{news.title}}</h3>
								<p>{{news.content}}</p>
								<span>{{formatDate(news.createDate)}}</span>
							</router-link>
						</div>
					</div>
				</div>
				<div v-else class="no-data-text">暂时没有内容喔~</div>
			</swiper-slide>

			<swiper-slide class="swiper-slide slide-three">
				<div class="page">
					<h3>患者之声</h3>
					<p>CASES</p>
				</div>
				<ul v-if="caseList != ''" class="case-item">
					<li v-for="(item, index) in caseList" :key="'case'+index"
						v-lazy:background-image="item.isWechatArticle==1?item.cdnUrl:item.mainImg.src">
						<div v-if="item.isWechatArticle==1" @click="goTo(item.url)" style="cursor: pointer;">
							<div class="case-item-hover">
								<p class="hover-title">{{item.title}}</p>
								<div class="bottom"></div>
								<div class="more">
									<span>MORE</span>
								</div>
							</div>
						</div>
						<router-link v-else target="_blank" rel="noopener noreferrer" class="text-decoration"
							:to="{ name: 'article', params: { id: item.id }}">
							<div class="case-item-hover">
								<p class="hover-title">{{item.title}}</p>
								<div class="bottom"></div>
								<div class="more">
									<span>MORE</span>
								</div>
							</div>
						</router-link>
					</li>
				</ul>
				<div v-else class="no-data-text">暂时没有内容喔~</div>
			</swiper-slide>

		</swiper>
	</div>
</template>

<script>
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	export default {
		name: "HelloWorld",
		components: {
			swiper,
			swiperSlide
		},
		data() {
			return {
				loading: false,
				caseList: [],
				newsList: [],
				swiperOption: {
					notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
					direction: "vertical", //水平方向移动
					grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
					setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
					autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
					slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
					mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
					mousewheelControl: true, //同上
					height: window.innerHeight - 60, // 高度设置，占满设备高度
					resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
					observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

					// 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
					//debugger: true,

					// swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
					on: {
						//监听滑动切换事件，返回swiper对象
						// slideChange: () => {
						//   let swiper = this.$refs.mySwiper.swiper;
						//   //console.log(swiper.activeIndex); //滑动打印当前索引
						//   if (swiper.activeIndex === this.list.length - 1) {
						//     //到最后一个加载更多数据
						//     let newList = [];
						//     let listLength = this.list.length;
						//     for (let i = 0; i < 10; i++) {
						//       newList.push(listLength + i);
						//     }
						//     this.list = this.list.concat(newList);
						//   }
						// }
					}
				}
			};
		},
		created() {},
		// 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper;
			}
		},
		mounted() {
			this.loadData();
		},
		methods: {
			loadData() {
				this.$http
					.all([
						this.$http.post("/article/getListToShowByPage", {
							type: 4,
							part: 1,
							pageSize: 4,
							currentPage: 1,
						}),
						this.$http.post("/article/getListToShowByPage", {
							type: 4,
							part: 5,
							pageSize: 6,
							currentPage: 1,
						})
					])
					.then(
						this.$http.spread((responsePart1, responsePart5) => {
							// console.log(responseCases.data);
							window.console.log(responsePart5.data);
							this.newsList = responsePart1.data.data.articleList;
							this.caseList = responsePart5.data.data.articleList;
						})
					);
			},
			goTo(url) {
				window.open(url);
			},
			//时间格式化
			formatDate(isoString) {
				const date = new Date(isoString);

				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
		}
	};
</script>

<style lang="scss" scoped>
	/* .el-header {
  position: absolute;
} */
	.swiper-slide {
		font-size: 24px;
		// text-align: center;
		// line-height: 100px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;

		.page {
			text-align: center;
			height: 100px;
			overflow: hidden;

			h3,
			p {
				font-size: 40px;
				font-weight: 400;
				color: #fff;
				text-shadow: 0px 0px 10px #972326;
			}
		}

		.slogan {
			text-align: center;
			font-size: 80px;
			color: #fff;
			text-shadow: 0px 0px 10px #972326;
			padding: 30px 0;
		}
	}

	// 无内容时
	.no-data-text {
		height: 500px;
		margin: 0 auto;
		color: #fff;
		font-size: 20px;
		line-height: 500px;
	}

	//经典案例
	.case-item {
		width: 1050px;
		height: 500px;
		// overflow: hidden;
		margin: 0 auto;
		margin-top: 30px;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;

		li {
			width: 330px;
			height: 250px;
			list-style: none;
			border-radius: 8px;
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			background-origin: content-box;
			margin: 10px;
			position: relative;
			overflow: hidden;

			box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.4);
			transition: all 0.4s ease;

			&:hover {
				box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.4);
				transform: scale(1.05);
				/* 示例样式 */
				// border: 1px solid #fff;

				transition: all 0.4s ease;

				.case-item-hover {
					opacity: 1;
					transform: scale(1.05);
					transition: all 0.4s ease-in-out;
				}
			}
		}
	}

	//经典案例hover
	.case-item-hover {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		opacity: 0;
		overflow: hidden;
		background-color: rgba(151, 35, 38, 0.5);

		.hover-title {
			width: 270px;
			margin: 0 30px;
			height: 50px;
			color: #fff;
			font-size: 18px;
			overflow: hidden;
			text-overflow: ellipsis;
			text-align: center;
			line-height: 50px;
			white-space: nowrap;
			font-weight: 400;
			margin-top: 20px;
		}

		.bottom {
			border-bottom: 1px solid #fff;
			width: 60px;
			margin: 0 auto;
		}

		.more {
			width: 90px;
			padding: 5px 5px;
			margin: 0 auto;
			margin-top: 100px;
			border: 2px solid #fff;
			border-radius: 5px;
			text-align: center;

			span {
				color: #fff;
				font-size: 20px;

			}
		}
	}

	// .swiper-slide:nth-child(2n) {
	//   background: skyblue;
	// }
	// .swiper-slide:nth-child(2n-1) {
	//   background: seashell;
	// }
	.slide-one {
		background: url(../assets/首页图/首页图1.jpg) no-repeat center;
		background-size: cover;
	}

	.slide-two {
		background: url(../assets/首页图/首页图2.jpg) no-repeat center;
		background-size: cover;
	}

	.slide-three {
		background: url(../assets/首页图/首页图3.jpg) no-repeat center;
		background-size: cover;
	}

	//最新资讯
	.news-content {
		width: 1240px;
		margin: 0 auto;
		margin-top: 40px;
		display: flex;
		justify-content: center;
		// overflow: scroll;

		&-item {
			width: 400px;
			display: flex;
			flex-direction: column;


			.item-img {
				width: 376px;
				height: 160px;
				background-color: #f8f8f8;
				background-repeat: no-repeat;
				background-size: contain;	
				background-position: center;
				background-origin: content-box;
				// filter: opacity(0.6); /* 值为0-1，0.7表示70%不透明度 */
				margin: 0 auto;
				border: 1px solid rgba(151, 35, 38, 0.4);
				border-radius: 10px;
				transition: all 0.3s ease;

				box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.3);

			}

			.el-divider {
				background-color: #fff;
				height: 3px;

				.el-divider__text {
					width: 20px;
					height: 20px;
					border-radius: 50%;
					padding: 0px;
					color: #fff;
				}
			}

			.item-content {
				width: 356px;
				height: 210px;
				// margin: 0 auto;
				margin: 0 10px;
				padding: 10px;
				border: 1px solid rgba(151, 35, 38, 0.4);
				border-radius: 10px;
				// background-color: rgba(151, 35, 38, 0.1);
				background-color: rgba(0, 0, 0, 0.15);
				transition: all 0.3s ease;

				box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.3);

				//border: 1px solid paleturquoise;
				h3 {
					font-size: 24px;
					height: 70px;
					// 文本长度处理 begin
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					white-space: normal !important;
					word-wrap: break-word;
					// 文本长度处理 ending
					text-shadow:
						-1px -1px 0 rgba(151, 35, 38, 0.4),
						1px -1px 0 rgba(151, 35, 38, 0.4),
						-1px 1px 0 rgba(151, 35, 38, 0.4),
						1px 1px 0 rgba(151, 35, 38, 0.4);
				}

				p {
					font-size: 18px;
					height: 105px;
					overflow: hidden;
					margin: 10px 0;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 4;
					-webkit-box-orient: vertical;
					white-space: normal !important;
					word-wrap: break-word;
				}

				span {
					display: block;
					font-size: 16px;
					text-align: end;
				}

				h3,
				p,
				span {
					color: #fff;
				}
			}
		}
	}

	/* 当鼠标悬停在item-img或其父元素上时，影响item-content */
	.news-content-item:hover .item-content {
		/* 这里写item-content的hover样式 */
		background-color: rgba(151, 35, 38, 0.5);
		/* 示例样式 */
		transform: scale(1.05);
		/* 示例样式 */
		border: 1px solid #fff;
		box-shadow: 0 0 5px 5px rgba(151, 35, 38, 0.4);
		transition: all 0.3s ease;
	}

	/* 当鼠标悬停在item-content上时，影响item-img */
	.news-content-item:hover .item-img {
		/* 这里写item-img的hover样式 */
		transform: scale(1.05);
		/* 示例样式 */
		border: 1px solid #fff;
		box-shadow: 0 0 5px 5px rgba(151, 35, 38, 0.4);
		transition: all 0.3s ease;
		// filter: opacity(1);
	}

	.text-decoration {
		text-decoration: none;
	}

	.order {
		order: -1;
	}

	.order-img {
		order: 1;
	}
</style>